import { EEthereumNetworkId } from '@ankr.com/provider';

import { ContractsManager } from 'modules/core';

import { api } from '../api';
import { cacheTags } from '../cacheTags';

export const {
  useGetChainIdQuery,
  endpoints: { getChainId },
} = api.injectEndpoints({
  endpoints: build => ({
    getChainId: build.query<EEthereumNetworkId | null, void>({
      queryFn: async () => {
        const instance = await ContractsManager.getInstance();

        return { data: await instance.getChainId() };
      },
      providesTags: [cacheTags.chainData],
    }),
  }),
});
